import { Box } from '@mantine/core';
import { IconPointFilled as EvaluationIcon } from '@tabler/icons-react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Outlet, createFileRoute } from '@tanstack/react-router';

import { OpenGovEvaluationBox } from '@/module/GovEvaluation/components/OpenGovEvaluationBox';
import { getGovEvaluationsOptions } from '@/module/GovEvaluation/model/GovEvaluationQuery';

import { NoContentPlaceholder } from '@/core/components';
import { ContextSidebar } from '@/core/components/RootLayout/Sidebar/ContextSidebar';

import { useCurrentUser } from '@feature/security';

export const Route = createFileRoute('/_auth/gov-evaluation/_layout')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.govEvaluation' },
  },
  loader: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData(getGovEvaluationsOptions());
  },
});

function RouteComponent() {
  const { data } = useSuspenseQuery(getGovEvaluationsOptions());
  const { currentRole } = useCurrentUser();
  const currentEvaluationYear = new Date().getFullYear();

  const currentEvaluationExists = data.filter(ev => ev.year === currentEvaluationYear).length > 0;

  const tabs = data.map(evaluation => ({
    label: `Raportare CNFIS ${evaluation.year}`,
    to: `/gov-evaluation/${evaluation.id}`,
    icon: EvaluationIcon,
  }));

  return (
    <Box p="md">
      {!currentEvaluationExists && currentRole === 'UNIVERSITY_ADMIN' && (
        <Box mb="15px">
          <OpenGovEvaluationBox year={currentEvaluationYear} />
        </Box>
      )}
      {data?.length > 0 && (
        <>
          <ContextSidebar
            baseUrl=""
            items={tabs}
          />
          <Outlet />
        </>
      )}
      {data?.length === 0 && <NoContentPlaceholder title="Nu a fost deschis pentru raportare nici un raport CNFIS" />}
    </Box>
  );
}
